import React from "react";
import { enqueueSnackbar } from "notistack";
import { isApp } from "../../../../hooks/useNativeApp";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userState } from "../../../../recoil/auth";
import { loadingState } from "../../../../recoil/app";
import {
  registerReservation,
  reservationCancel,
} from "../../../../api/reservation";
import {
  ButtonWrapper,
  ContentWrapper,
  DialogWrapper,
  FormContainer,
} from "../../CompanyReservation/style/PopupStyles";

interface ReservationPopupProps {
  onClose: () => void;
  reservationId: number;
  setIsFinalReservation: (value: boolean) => void;
  keepSeed: number;
  type: string;
  tournamentName: string;
  id: number;
  pubType?: string;
}

const ReservationPopup: React.FC<ReservationPopupProps> = ({
  onClose,
  reservationId,
  setIsFinalReservation,
  keepSeed,
  type,
  tournamentName,
  id,
}) => {
  const [user] = useRecoilState(userState);
  const setIsLoading = useSetRecoilState(loadingState);
  const createReservation = async () => {
    if (!user) return;
    const pubBody = {
      reservationId: +reservationId,
      userId: user.id,
      route: isApp ? "APP" : "WEB",
      nickname: user.nickname,
      phoneNumber: "",
    };
    if (user.seed) {
      if (keepSeed > user.seed) {
        enqueueSnackbar("보유 래빗이 부족합니다. ");
        return;
      }
    } else {
      enqueueSnackbar("보유 래빗이 부족합니다. ");
      return;
    }
    try {
      setIsLoading(true);
      await registerReservation(pubBody);

      setIsFinalReservation(true);
      onClose();
    } catch (error: any) {
      onClose();
      enqueueSnackbar(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelReservation = async () => {
    if (!user) return;

    try {
      setIsLoading(true);
      await reservationCancel(id);
      setIsFinalReservation(true);
      onClose();
    } catch (error: any) {
      onClose();
      enqueueSnackbar(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogWrapper>
      <FormContainer>
        <ContentWrapper>
          {type === "reservation" ? (
            <>
              <div className="seed-wrapper">
                <div className="title">보유 래빗</div>
                <div className="seed">
                  {user?.seed ? user?.seed.toLocaleString() : 0} RABBIT
                </div>
              </div>
              <div className="content">토너먼트를 예약 하시겠습니까?</div>
              <div className="waring">
                *크레딧 {keepSeed}RABBIT 만큼 차감됩니다.
              </div>
            </>
          ) : (
            <>
              <div className="content-cancel">
                {tournamentName}
                <br />
                예약을 취소하시겠습니까?
              </div>
            </>
          )}
        </ContentWrapper>
        <ButtonWrapper>
          <div className="button" onClick={() => onClose()}>
            아니오
          </div>
          <div
            className="button purple"
            onClick={() => {
              if (type === "reservation") {
                createReservation();
              } else {
                cancelReservation();
              }
            }}
          >
            예
          </div>
        </ButtonWrapper>
      </FormContainer>
    </DialogWrapper>
  );
};

export default ReservationPopup;
